module.exports = __webpack_public_path__ + "img/thumb-009-17.a8ac82ff.png";